<template>
  <layout-main-inner title="账号管理">
    <div slot="action">
      <!-- <el-button
        type="primary"
        @click="selectitem">
        新增账号
      </el-button> -->
      <el-dropdown>
        <el-button
          type="primary"
          style="margin-left: 10px;">
          更多<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="selectitem">新增员工账号</el-dropdown-item>
          <!-- <el-dropdown-item @click.native="()=> {additem({},2)}">新增普通账号</el-dropdown-item> -->
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <layout-card-wrap>
      <!-- <template slot="form">
        <el-input
          v-model="config.quarantineName"
          clearable
          placeholder="请输入分类名称"
          @clear="handleCurrentChange(1)"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"
          ></el-button>
        </el-input>
      </template> -->
      <el-table
        border
        :data="list">
        <el-table-column
          label="账号"
          prop="account"> </el-table-column>
        <el-table-column
          label="姓名"
          prop="staffName"> </el-table-column>
        <el-table-column
          v-if="userInfo.userType === 506"
          min-width="240"
          label="业务范围">
          <template slot-scope="{ row }">
            <!-- <div
              v-for="item in row.servicePermmisions"
              :key="item.serviceId">
              {{ item.serviceName }}
            </div> -->
            {{ row.servicePermmisionsStr }}
          </template>
        </el-table-column>
        <el-table-column
          label="功能"
          min-width="300">
          <template slot-scope="{ row }">
            <!-- <div
              v-for="item in row.functions"
              :key="item.funcId">
              {{ item.funcName }}
            </div> -->
            {{ row.functionsStr }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="145">
          <template slot-scope="{ row }">
            <el-button
              v-if="row.isAdmin !== 1"
              type="info"
              @click="updateitem(row)"
            >
              编辑
            </el-button>
            <el-button
              v-if="row.isAdmin !== 1"
              type="danger"
              @click="deleteitem(row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </layout-card-wrap>
    <user-select-modal
      ref="select"
      :callback="
        (r) => {
          additem(r,1);
        }
      "
    />
    <edit-user-modal
      ref="user"
      :callback="
        () => {
          fetchList();
        }
      "
    />
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import UserSelectModal from './user-select-modal.vue'
import EditUserModal from './edit-user-modal.vue'

export default {
  name: 'CategorysIndex',
  components: { UserSelectModal, EditUserModal },
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      config: {
        pageNum: 1,
        pageSize: 10,
        operTypes: [0]
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo
    })
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    updateitem(row) {
      const operations = {}
      const functions = row.functions || []
      functions.forEach((i) => {
        // i.operations.forEach((s) => {
        //   operations.push(s.operation)
        // })
        operations[i.funcId] = i.operations.map(s => s.operation)
        // {
        //   // operations: i.operations,
        //   operation: i.operations.map(s => s.operation)
        // }
      })
      this.$refs.user.update({
        staffId: row.staffId,
        orgId: row.orgId,
        staffName: row.staffName,
        account: row.account,
        servicePermmisions: (row.servicePermmisions || []).map(
          (i) => i.serviceId
        ),
        functions: row.functions.map((i) => i.funcId),
        mobile: row.mobile,
        operations
      })
    },
    selectitem() {
      this.$refs.select.fetch()
    },
    additem(row = {}, type) {
      console.log(row)
      this.$refs.user.add(row, type)
    },
    deleteitem(row) {
      console.log(row)
      this.$confirm('您确定删除该账号?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('account/deletestaff', {
          payload: {
            staffId: row.staffId
          },
          success: () => {
            this.loading = false
            this.fetchList()
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      this.$store.dispatch('account/getstaffs', {
        payload: { ...this.config, orgId: this.userInfo.orgId },
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records.map(i => {
            return {
              ...i,
              functionsStr: i.functions.map(s => s.funcName).join('，'),
              servicePermmisionsStr: i.servicePermmisions.map(s => s.serviceName).join('，')
            }
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
